import { isBrowser as n } from "./client.js";
const t = () => n() && "ResizeObserver" in window, b = ({
  $el: r,
  callback: s,
  autoUnobserve: i = !0
}) => {
  if (!t())
    return;
  const e = new ResizeObserver((o) => {
    s(o, e), i && e.unobserve(r);
  });
  return e.observe(r), e;
};
export {
  b as createObserver,
  t as isResizeObserverAvailable
};
